import { ClerkProvider } from '@/app/providers/clerk-provider';
import { router } from '@/app/router';
import { queryClient } from '@/shared/api/query-client';
import { trpc, trpcClient } from '@/shared/api/trpc';
import { ensureFreshShell } from '@/shared/lib/ensure-fresh-shell';
import '@/shared/config/globals.css';
import '@travel-planner/customer-preview-view/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import React from 'react';
import ReactDOM from 'react-dom/client';

const mount = () => {
  const rootElement = document.getElementById('root');

  if (rootElement && !rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <ClerkProvider>
          <trpc.Provider client={trpcClient} queryClient={queryClient}>
            <QueryClientProvider client={queryClient}>
              <RouterProvider router={router} />
            </QueryClientProvider>
          </trpc.Provider>
        </ClerkProvider>
      </React.StrictMode>
    );
  }
};

// XT-413: if this bundle's SHA disagrees with live /build-id.json (no-store),
// reload once onto a fresher shell before mounting React. The probe is
// timeout-bounded and swallows its own failures, but mounting is too important
// to leave resting on that — `catch` guarantees the app still comes up.
void ensureFreshShell()
  .then((result) => {
    if (result === 'reloading') return;
    mount();
  })
  .catch(() => mount());
